var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("div", { staticClass: "modal-overlay" }, [
        _c("div", { staticClass: "open-member-dialog" }, [
          _c(
            "div",
            {
              staticClass: "head-body",
              class: {
                "bg-normal": _vm.userVipInfo.vip_status == 0,
                "bg-active": _vm.userVipInfo.vip_status == 1
              }
            },
            [
              _c("div", { staticClass: "head-body-msg" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "head-tips",
                    class: { "tips-vip": _vm.userVipInfo.vip_status == 1 }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(
                          _vm.userVipInfo.vip_status == 0
                            ? "你还不是快兔会员，无法享受会员权益"
                            : "会员有效期至 " +
                                _vm.userVipInfo.vip_info.time_end
                        ) +
                        "\n\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "close-btn", on: { click: _vm.closeDialog } },
                  [
                    _c("img", {
                      attrs: { src: require("@/assets/ic_close.png"), alt: "" }
                    })
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "body-content" }, [
            _c("div", { staticClass: "content-left" }, [
              _c("div", { staticClass: "content-left-body" }, [
                _c("div", { staticClass: "left-main" }, [
                  _c("div", { staticClass: "left-main-title" }, [
                    _vm._v("会员尊享权益")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "left-main-list" },
                    _vm._l(_vm.memberOptions, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "left-main-list-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "left-main-list-item-icon" },
                            [_c("img", { attrs: { src: item.icon, alt: "" } })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "left-main-list-item-title" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(item.title) +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.productsArr.length > 0
              ? _c("div", { staticClass: "content-right" }, [
                  _c("div", { staticClass: "content-right-body" }, [
                    _c(
                      "div",
                      {
                        staticClass: "products-list-container",
                        on: {
                          mouseenter: _vm.showDirection,
                          mouseleave: _vm.hideDirection
                        }
                      },
                      [
                        _c(
                          "div",
                          { ref: "productsList", staticClass: "products-list" },
                          _vm._l(_vm.productsArr, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "product-item",
                                class: {
                                  active: _vm.selectedProductIndex === index
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectProduct(index)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "product-item-body",
                                    class: {
                                      "product-item-body-selected":
                                        _vm.selectedProductIndex === index
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "product-title",
                                        class: {
                                          "product-title-selected":
                                            _vm.selectedProductIndex === index
                                        }
                                      },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "product-price-body",
                                        class: {
                                          "product-price-body-selected":
                                            _vm.selectedProductIndex === index
                                        }
                                      },
                                      [
                                        _c("div", [_vm._v("¥")]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              item.first_price > 0
                                                ? item.first_price
                                                : item.sell_price
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "product-price-show",
                                        class: {
                                          "product-price-show-selected":
                                            _vm.selectedProductIndex === index
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t¥" +
                                            _vm._s(item.show_price)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "product-price-discount",
                                        class: {
                                          "product-price-discount-selected":
                                            _vm.selectedProductIndex === index
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t立减¥" +
                                            _vm._s(item.unit_price2)
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                item.label_id != 0
                                  ? _c(
                                      "div",
                                      { staticClass: "product-lable" },
                                      [_vm._v(_vm._s(item.label))]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.productsArr.length >= 5 && _vm.isShowDirection
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "icon-direction icon-direction-left",
                                on: {
                                  click: function($event) {
                                    return _vm.scrollList("left")
                                  },
                                  mouseenter: _vm.showDirection
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/ic_direction.png"),
                                    alt: ""
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.productsArr.length >= 5 && _vm.isShowDirection
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "icon-direction icon-direction-right",
                                on: {
                                  click: function($event) {
                                    return _vm.scrollList("right")
                                  },
                                  mouseenter: _vm.showDirection
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/ic_direction.png"),
                                    alt: ""
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "auto-renew-tip" }, [
                      _vm.productsArr.length > 0
                        ? _c("div", { staticClass: "auto-renew-tip-title" }, [
                            _vm._v(
                              "自动续费" +
                                _vm._s(
                                  _vm.productsArr[_vm.selectedProductIndex]
                                    .sell_price
                                ) +
                                "/月，可随时取消"
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.payArr.length > 0
                      ? _c("div", { staticClass: "pay-content" }, [
                          _c("div", { staticClass: "qrcode-body" }, [
                            _c("div", { staticClass: "qrcode-body-content" }, [
                              _c(
                                "div",
                                { staticClass: "qrcode" },
                                [
                                  _c("QrcodeGenerator", {
                                    attrs: {
                                      text: _vm.qrCodeText,
                                      size: 120,
                                      options: {
                                        color: {
                                          dark: "#000000",
                                          light: "#ffffff"
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.isQrCodeExpired
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "refresh-body",
                                          on: { click: _vm.refreshQrCode }
                                        },
                                        [
                                          _vm._m(1),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "refresh-tip" },
                                            [_vm._v("点击刷新二维码")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "qrcode-title" }, [
                                _vm._v(
                                  "打开" +
                                    _vm._s(
                                      _vm.payArr.find(function(item) {
                                        return (
                                          item.payment_id ===
                                          _vm.selectedPayType
                                        )
                                      }).payment_name
                                    ) +
                                    "扫一扫"
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pay-type-body" }, [
                            _c(
                              "div",
                              { staticClass: "pay-type-body-content" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "pay-type-arr" },
                                  _vm._l(_vm.payArr, function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "pay-item",
                                        class: {
                                          "pay-item-selected":
                                            _vm.selectedPayType ===
                                            item.payment_id
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.changePayType(
                                              item.payment_id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("div"),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(_vm._s(item.payment_name))
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "hong-bao-body" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "hong-bao-title" }, [
                                    _vm._v(
                                      "限时优惠，" +
                                        _vm._s(_vm.formattedCountdown) +
                                        "后失效"
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "price-agreement-body" }, [
                              _c("div", { staticClass: "price-body" }, [
                                _c("div", { staticClass: "price-title" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t同意协议并支付\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "price-value" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t¥" +
                                      _vm._s(
                                        _vm.productsArr[
                                          _vm.selectedProductIndex
                                        ].first_price > 0
                                          ? _vm.productsArr[
                                              _vm.selectedProductIndex
                                            ].first_price
                                          : _vm.productsArr[
                                              _vm.selectedProductIndex
                                            ].sell_price
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "price-show" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t¥" +
                                      _vm._s(
                                        _vm.productsArr[
                                          _vm.selectedProductIndex
                                        ].show_price
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "agreement-body" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "icon",
                                    on: {
                                      click: function($event) {
                                        _vm.agreeAgreement = !_vm.agreeAgreement
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.agreeAgreement
                                          ? require("@/assets/check_square_y.png")
                                          : require("@/assets/check_square_n.png"),
                                        alt: ""
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "agreement-title" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t请阅读并同意\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "agreement-content" },
                                  [
                                    _vm.productsArr[_vm.selectedProductIndex]
                                      .auto_renew == 1
                                      ? _c(
                                          "label",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.clickTerm(1)
                                              }
                                            }
                                          },
                                          [_vm._v("续费协议")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.productsArr[_vm.selectedProductIndex]
                                      .auto_renew == 1
                                      ? _c("label", [_vm._v("|")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.clickTerm(2)
                                          }
                                        }
                                      },
                                      [_vm._v("用户协议")]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-name" }, [
      _c("img", {
        attrs: { src: require("@/assets/member_name.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "refresh-ic" }, [
      _c("img", { attrs: { src: require("@/assets/ic_refresh.png"), alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("@/assets/ic_hongbao.png"), alt: "" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b984768", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b984768","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/open_member_dialog.vue
// module id = null
// module chunks = 